module.exports = __webpack_public_path__ + "img/bgUrl.0c55c7c2.png";